<template>
  <div class="body">
    <div class="logo-wrapper">
      <img :src="require('./assets/harmony.svg')" alt="Logo" class="logo" />
    </div>
    <div class="content-center">
      <router-view></router-view>
    </div>
  </div>
</template>


<script>

export default ({
  name: 'App'

})
</script>

<style lang="scss">
@import '../src/scss/style.scss';

.body {
  background-color: #1b1a47;
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  
}

.body::before {
  content: "";
  position: absolute;
  inset: 0;
}

.body > * {
  position: relative;
  z-index: 1;
}

.logo-wrapper {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
}

.logo {
  max-height: 60px;
  width: auto;
}


  .content-center {
    z-index: 1;
    max-width: 500px; 
    padding: 1rem;
    margin-left: 90px;
  }

@media (max-width: 768px) {
  .logo-wrapper {
    top: 10px;
    left: 10px;
    padding: 4px 8px;
  }

  .logo {
    max-height: 30px;
  }

  .content-center {
    padding: 0.5rem;
  }
}

</style>
